export default __webpack_public_path__ + "static/media/housing.923040ee.jpg";